import { TranslationService } from "@/core/services/TranslationService";
import SiteUser from "@/views/site/views/SiteUser.vue";
import SiteForms from "@/views/site/views/SiteForms.vue";
import SiteActivity from "@/views/site/views/SiteActivity.vue";
import DeviceActivity from "@/views/site/views/SiteDevicesActivity.vue";
// import SiteLocationDevices from "@/views/site/views/SiteLocationDevices.vue";
import SiteDetail from "@/views/site/views/SiteDetail.vue";
import DeviceDetail from "@/views/site/views/DeviceDetail.vue";
import SiteDevice from "@/views/site/views/SiteDevice.vue";
import DeviceSite from "@/views/site/views/DeviceSite.vue";
import SiteLocation from "@/views/site/views/SiteLocation.vue";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
import { boolean } from "yup";

export function siteTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.siteName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.site.siteNumber"),
      key: "code",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.siteLevel"),
      key: "typeTextCode",
      sortable: false,
    },
    {
      name: TranslationService.translate("pages.site.address"),
      key: "address",
      sortName: "City",
      sortable: true,
      sortingField: "address.city",
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: "",
      key: "clone",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function siteUserTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.userName"),
      key: "name",
      sortable: true,
      sortingField: "userAccount.firstName",
    },
    {
      name: TranslationService.translate("pages.site.role"),
      key: "roleName",
      sortable: true,
      sortingField: "userRole.role.roleName",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function siteFormsTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.formName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "assignDate",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function siteLocationDevicesTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.deviceName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.site.uuid"),
      key: "uuid",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
    },
    {
      name: TranslationService.translate("common.type"),
      key: "type",
    },
    {
      name: TranslationService.translate("pages.site.locationCode"),
      key: "locationCode",
    },
    {
      name: TranslationService.translate("pages.site.macAddress"),
      key: "macAddress",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("pages.site.siteDeviceStatus"),
      key: "siteDeviceStatus",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.site.locationStatus"),
      key: "locationStatus",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function siteDevicesTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.deviceName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.location.locationName"),
      key: "locationName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.type"),
      key: "typeTextCode",
    },
    {
      name: TranslationService.translate("pages.site.uuid"),
      key: "uuId",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.site.macAddress"),
      key: "macAddress",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function siteTableFilters() {
  return [
    {
      key: "city",
      label: TranslationService.translate("City"),
      type: "text",
      textKey: "city",
      valueKey: "value",
    },
    {
      key: "state",
      label: TranslationService.translate("State"),
      type: "text",
      textKey: "state",
      valueKey: "value",
    },
    {
      key: "postalCode",
      label: TranslationService.translate("Postal Code"),
      type: "text",
      textKey: "postalCode",
      valueKey: "value",
    },
    {
      key: "filterSiteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function siteUserTableFilters() {
  return [
    {
      key: "userIds",
      label: TranslationService.translate("common.users"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "roleIds",
      label: TranslationService.translate("common.roles"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/ROLES",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function siteFormsTableFilters() {
  return [
    {
      key: "siteFormDefinitionIds",
      label: TranslationService.translate("common.forms"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "ALL" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}
export function siteLocationTableFilters() {
  return [
    {
      key: "filterLocationIds",
      label: TranslationService.translate("pages.location.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/LOCATION",
      textKey: "text",
      valueKey: "value",
    },
  ];
}
export function siteLocationDevicesTableFilters() {
  return [
    {
      key: "siteDevicesIds",
      label: TranslationService.translate("pages.site.siteDevice"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function siteDevicesTableFilters() {
  return [
    {
      key: "filterDeviceIds",
      label: TranslationService.translate("common.devices"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/DEVICES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "filterSiteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "filterLocationIds",
      label: TranslationService.translate("pages.location.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/LOCATION",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "type",
      label: TranslationService.translate("common.type"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKDeviceType",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function siteTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "sites",
    entityLabel: TranslationService.translate("pages.site.title"),
  };
}

export function siteUserTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "userSites",
    entityLabel: TranslationService.translate("common.users"),
  };
}

export function siteFormsTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "siteForms",
    entityLabel: TranslationService.translate("common.forms"),
  };
}

export function siteLocationDevicesTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "siteDevices",
    entityLabel: TranslationService.translate("common.devices"),
  };
}

export function siteDevicesTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "devices",
    entityLabel: TranslationService.translate("common.devices"),
  };
}

export function siteActivityTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.dateTime"),
      key: "createdDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.user"),
      key: "createdBy",
      sortable: true,
    },
    // {
    //   name: TranslationService.translate("common.type"),
    //   key: "typeCodeText",
    // },
    {
      name: TranslationService.translate("common.event"),
      key: "descriptions",
      sortable: true,
      sortingField: "description",
      attrs: {
        class: "vz-dataTable-left",
      },
    },
  ];
}

export function siteActivityTableFilters(): IDataTableFilterOption[] {
  return [
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "userIds",
      label: TranslationService.translate("common.users"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function deviceActivityTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.dateTime"),
      key: "createdDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.user"),
      key: "createdBy",
      sortable: true,
    },
    // {
    //   name: TranslationService.translate("common.type"),
    //   key: "typeCodeText",
    // },
    {
      name: TranslationService.translate("common.event"),
      key: "descriptions",
      sortable: false,
      attrs: {
        class: "vz-dataTable-left",
      },
    },
  ];
}

export function deviceActivityTableFilters(): IDataTableFilterOption[] {
  return [
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
  ];
}

export function SiteDeviceTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.deviceName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.location.locationName"),
      key: "locationName",
      sortable: true,
      sortingField: "location.name",
    },
    // {
    //   name: TranslationService.translate("common.assignedDate"),
    //   key: "assignDate",
    //   sortable: true,
    // },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function SiteDeviceTableFilters() {
  return [
    {
      key: "deviceIds",
      label: TranslationService.translate("common.devices"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/DEVICES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "filterLocationIds",
      label: TranslationService.translate("pages.location.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/LOCATION",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function SiteDeviceTableBulkDelete() {
  return {
    showDelete: true,
    key: "siteDeviceId",
    entity: "lookupsData",
    entityLabel: TranslationService.translate("common.devices"),
  };
}

export function DeviceSiteTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.siteName"),
      key: "name",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "assignDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function DeviceSiteTableFilters() {
  return [
    {
      key: "siteIds",
      label: TranslationService.translate("common.name"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function DeviceSiteTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookupsData",
    entityLabel: TranslationService.translate("common.sites"),
  };
}

export const DEVICE_LOOKUP = {
  url: "site/filter/DEVICES",
  textKey: "text",
  valueKey: "value",
};

export const SITE_LOOKUP = {
  url: "site/filter/SITES",
  textKey: "text",
  valueKey: "value",
};

export function SITE_TABS() {
  return [
    {
      title: TranslationService.translate("common.detail"),
      name: "site.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: SiteDetail,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("common.users"),
      name: "site.user",
      icon: "bi bi-people me-2 fs-4 text-primary",
      component: SiteUser,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("pages.site.siteForms"),
      name: "site.form",
      icon: "bi bi-layers me-2 fs-3 text-primary align-middle mb-1",
      component: SiteForms,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("pages.location.title"),
      name: "site.location",
      icon: "bi bi-geo-alt me-2 fs-4 text-primary align-middle mb-1",
      component: SiteLocation,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("pages.site.device"),
      name: "site.device",
      icon: "bi bi-cpu me-2 fs-4 text-primary",
      component: SiteDevice,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("common.activity"),
      name: "site.activity",
      icon: "bi bi-signpost-2 me-2 fs-4 text-primary",
      component: SiteActivity,
      props: {
        data: {},
      },
    },
  ];
}

export function SITE_DEVICES_TABS() {
  return [
    {
      title: TranslationService.translate("common.detail"),
      name: "device.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: DeviceDetail,
      props: {
        data: {},
      },
    },
    // {
    //   title: TranslationService.translate("common.sites"),
    //   name: "device.site",
    //   icon: "bi bi-diagram-3 me-2 fs-4 text-primary",
    //   component: DeviceSite,
    //   props: {
    //     data: {},
    //   },
    // },
    {
      title: TranslationService.translate("common.activity"),
      name: "site.activity",
      icon: "bi bi-signpost-2 me-2 fs-4 text-primary",
      component: DeviceActivity,
      props: {
        data: {},
      },
    },
  ];
}
export function DocumentsTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.documentName"),
      key: "documentName",
      sortable: true,
      sortingField: "documentName",
    },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
    },
    {
      name: TranslationService.translate("common.username"),
      key: "userName",
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.audio"),
      key: "audio",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.generateReport"),
      key: "generatePDF",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}
export function DocumentsTableFilters() {
  return [
    {
      key: "formDefinitionIds",
      label: TranslationService.translate("common.documents"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "siteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "userIds",
      label: TranslationService.translate("common.users"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "scheduleStatus",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.completed"),
          value: "COMPLETED",
        },
        {
          label: TranslationService.translate("common.expired"),
          value: "EXPIRED",
        },
        {
          label: TranslationService.translate("common.scheduled"),
          value: "SCHEDULE",
        },
      ],
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
  ];
}
export function DocumentTableBulkDelete() {
  return {
    showDelete: false,
    key: "webId",
    entity: "siteUser",
    entityLabel: TranslationService.translate("common.users"),
  };
}

//////LocationSite////////
export function locationSiteTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.location.locationName"),
      key: "locationName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function siteLocationTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "siteLocations",
    entityLabel: TranslationService.translate("pages.site.title"),
  };
}

export function siteLocationsTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "siteLocations",
    entityLabel: TranslationService.translate("pages.location.title"),
  };
}
